export const PRODUCT_ID_MAX_LENGTH = 16;
export const productIdValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('products.validation.product-id-empty');
    } else if (input.length > PRODUCT_ID_MAX_LENGTH) {
        err = t('products.validation.product-id-too-long', { maxLength: PRODUCT_ID_MAX_LENGTH });
    } else if (!input.split('').every((char) => isAsciiChar(char))) {
        err = t('products.validation.product-id-invalid');
    }
    return err;
};

const isAsciiChar = (char) => char.charCodeAt(0) < 128;

export const PRODUCT_NAME_MAX_LENGTH = 64;
export const productNameValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('products.validation.product-name-empty');
    } else if (input.length > PRODUCT_NAME_MAX_LENGTH) {
        err = t('products.validation.product-name-too-long', { maxLength: PRODUCT_NAME_MAX_LENGTH });
    }
    return err;
};

export const PRODUCT_ISIN_CODE_LENGTH = 12;
export const isinCodeValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length !== PRODUCT_ISIN_CODE_LENGTH) {
        err = t('products.validation.product-isin-wrong-length');
    } else if (/^.*[a-z].*$/.test(input)) {
        err = t('products.validation.product-capitalized-letters');
    } else if (!/^[A-Z]{2}.{10}$/.test(input)) {
        err = t('products.validation.product-isin-wrong-submarket-code');
    } else if (!/^.{2}[A-Z0-9]{9}.$/.test(input)) {
        err = t('products.validation.product-isin-wrong-national-security-identifier');
    } else if (!/^.{11}[0-9]$/.test(input)) {
        err = t('products.validation.product-isin-wrong-check-digit');
    }
    return err;
};
